import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { PanelHeaderV2Desktop as TabsList } from './components/headers/panel-header-v2/desktop';
import { Tabs as Component } from './components/tabs';
import type { ITabsDeps, TTabs } from './components/tabs/models';

export const TabsPanelV2Desktop = createWidget<ITabsDeps, TTabs>({
    TabsList,
})(Component);
